/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrderItemCompany } from './order_item_company'
import type { OrderItemContact } from './order_item_contact'
/**
 * Заказчик/плательщик
 */
export type OrderItemClient = {
  /**
   * Тип клиента
   */
  type: OrderItemClient.type
  /**
   * Компания (юр. лицо). Обязательно при type=Legal, не указывается при type=Individual
   */
  company?: OrderItemCompany
  /**
   * Контакт (физ. лицо). Обязательно при type=Individual, не указывается при type=Legal
   */
  contact?: OrderItemContact
}
export namespace OrderItemClient {
  /**
   * Тип клиента
   */
  export enum type {
    LEGAL = 'legal',
    INDIVIDUAL = 'individual'
  }
}
